/* eslint-disable no-alert, no-console */
/* eslint-disable */

import React from "react";
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect,
} from "react-router-dom";
import { Routes } from "routes/Routes";
import SignIn from "../pages/auth/SignIn";
import SignUp from "../pages/auth/SignUp";
import CheckPassword from "../pages/auth/CheckPassword";
import VerifyAccount from "../pages/auth/VerifyAccount";
import ForgotPasswordEmail from "../pages/auth/ForgotPasswordEmail";
import RegisterComplete from "../pages/auth/RegisterComplete";
import { AuthContext } from "contexts/authContext";
import { AuthStatus, IAuth } from "interfaces/IAuth";
import { AuthPAGES } from "pages/auth/pages";
import ChangePhone from "pages/auth/ChangePhone";
import VerifyPhone from "pages/auth/VerifyPhone";
import VerifyTwoFA from "../pages/auth/VerifyTwoFA";

const AuthStackNavigation: React.FC = () => {
  // const { Navigator, Screen } = AuthStack;

  // const onboarding = useSelector((state: RootStateOrAny) => state.onboarding);
  const { authStatus }: IAuth = React.useContext(AuthContext);

  if (authStatus === AuthStatus.SignedIn) {
    return null;
  }

  return (
    <Router>
      <Switch>
        <Route exact path="/SignIn" component={SignIn} />
        <Route exact path="/SignUp" component={SignUp} />
        <Route exact path="/invitation_received" component={VerifyAccount} />
        <Route exact path="/RegisterComplete" component={RegisterComplete} />
        <Route exact path="/ForgotPasswordEmail" component={ForgotPasswordEmail} />
        <Route exact path="/CheckPassword" component={CheckPassword} />
        <Route exact path={`${AuthPAGES.changePhone}/:email`} component={ChangePhone} />
        <Route exact path={`${AuthPAGES.verifyPhone}/:phone/:email`} component={VerifyPhone} />
        <Route exact path="/VerifyTwoFA/:email" component={VerifyTwoFA} />
        <Route path="*" component={() => <Redirect to="/SignIn" />} />
      </Switch>
    </Router>
  );
};

export default AuthStackNavigation;
